import { render, staticRenderFns } from "./CardGrafico.vue?vue&type=template&id=45fe9b5c&scoped=true"
import script from "./CardGrafico.vue?vue&type=script&lang=js"
export * from "./CardGrafico.vue?vue&type=script&lang=js"
import style0 from "./CardGrafico.vue?vue&type=style&index=0&id=45fe9b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fe9b5c",
  null
  
)

export default component.exports